import { createFileRoute } from "@tanstack/react-router";
import { LuukkuPurchaseOrderImportView } from "src/tenantCustomizations/tenants/mellano/views/luukku/purchaseOrders/LuukkuPurchaseOrderImportView.tsx";

export const Route = createFileRoute("/_authenticated/_shell/mellano/luukku/purchaseOrderImport")({
	staticData: { title: "Luukun ostotilaukset", legacyViewKey: "mellanoLuukkuPurchaseOrderImportPage" },
	component: RouteComponent,
});

function RouteComponent() {
	return <LuukkuPurchaseOrderImportView />;
}
